import React, { forwardRef } from 'react';
import styled from 'styled-components';

/**
 * Icons are used to provide additional information and communicate messages to the user.
 * The component allows you to display an icon from design system icons library or a custom svg icon.
 */
const _Icon = forwardRef((props, ref) => {
    const { 'data-test-id': dataTestId, className, svg, style, ...rest } = props;
    return (React.createElement("span", { className: className, "data-test-id": dataTestId, style: style, ref: ref }, React.cloneElement(svg, { ...rest })));
});
_Icon.displayName = '_Icon';
const Icon = styled(_Icon)({
    display: 'inline-flex',
});

export { Icon };
//# sourceMappingURL=Icon.js.map
